(function () {
  function initMenuDrawerPromos(root) {
    var scope = root || document;
    var promoContainers = scope.querySelectorAll('[data-menu-drawer-promo]');

    promoContainers.forEach(function (promoContainer) {
      if (promoContainer.dataset.promoInitialized === 'true') return;

      var promoItems = Array.prototype.slice.call(
        promoContainer.querySelectorAll('[data-menu-drawer-promo-item]')
      );

      if (!promoItems.length) return;

      var currentPromoIndex = 0;

      function showPromo(nextIndex) {
        currentPromoIndex = (nextIndex + promoItems.length) % promoItems.length;

        promoItems.forEach(function (promoItem, promoIndex) {
          if (promoIndex === currentPromoIndex) {
            promoItem.classList.remove('hidden');
          } else {
            promoItem.classList.add('hidden');
          }
        });
      }

      var prevButton = promoContainer.querySelector('[data-menu-drawer-promo-nav="prev"]');
      var nextButton = promoContainer.querySelector('[data-menu-drawer-promo-nav="next"]');

      if (prevButton) {
        prevButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showPromo(currentPromoIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          showPromo(currentPromoIndex + 1);
        });
      }

      showPromo(0);
      promoContainer.dataset.promoInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMenuDrawerPromos(document);
    });
  } else {
    initMenuDrawerPromos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMenuDrawerPromos(event.target || document);
  });
})();
